import { Injectable } from '@angular/core';
import { JobStatus } from '../models/generated/ziroModels';
import { PollingAbstractService } from '../services/abstract/polling.abstract.service';

@Injectable()
export class DialPlanInventoriesPollingService extends PollingAbstractService<JobStatus> {
  baseUrl = '/services/cisco/reporting/directory-number-availability-reports/status';
}
